import { stripVTControlCharacters } from "node:util";
import { directUpload } from "@apis/directUpload";
import { Bar, Presets } from "cli-progress";
import { bytesToUnits, calculateLowestUnit } from "./fileHelpers";
export const evaluateStatus = (outcome, status) => {
    if (outcome === "flaky")
        return outcome;
    return status;
};
export const generateErrorReport = ({ location, snippet }) => {
    if (!location)
        return null;
    const { file, line, column } = location;
    return `# ${file} (${line}:${column}) \n\n\n ${snippet}`;
};
export const generateErrorSummary = ({ location, message, value, }) => {
    var _a;
    const [firstLine] = stripVTControlCharacters((_a = message !== null && message !== void 0 ? message : value) !== null && _a !== void 0 ? _a : "")
        .trim()
        .split("\n");
    const at = location && `at ${location.file}:${location.line}:${location.column}`;
    return [firstLine, at].filter(Boolean).join(" ");
};
export const uploadToS3 = async (data, { url, headers }, type) => {
    const unit = calculateLowestUnit(data.byteLength);
    const progressBar = new Bar({
        format: `Uploading ${type} [{bar}] | {value}/{total} ${unit} - ETA: {eta_formatted}`,
        clearOnComplete: true,
    }, Presets.rect);
    progressBar.start(bytesToUnits(data.byteLength, unit), 0);
    await directUpload(data, { url, headers }, {
        onUploadProgress: uploadEvent => {
            if (uploadEvent.total && uploadEvent.lengthComputable) {
                progressBar.update(bytesToUnits(uploadEvent.loaded, unit));
            }
        },
    });
    progressBar.stop();
    return progressBar;
};
//# sourceMappingURL=onTestEnd.js.map